import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import App from './App'
import ElementUI from 'element-ui'
import routes from './routers'
import axios from 'axios'
import qs from 'qs'
import store from './store/store'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/common.css'

Vue.config.productionTip = false
Vue.use(VueRouter);
const router = new VueRouter({routes})//引入路由
Vue.use(Vuex); //引入状态管理
Vue.use(ElementUI,{size:'small',zIndex:9999}); // 引入ElementUI，默认小视图


/*-- axios拦截 --*/
//设置文件上传拦截
var instance = axios.create({
	baseURL:'',
	timeout:180000000,
	headers: {'Content-Type':'multipart/form-data'}
});
Vue.prototype.instance = instance;
axios.interceptors.request.use(
	config => {
		if(JSON.parse(sessionStorage.getItem('token'))){
			config.headers.token = JSON.parse(sessionStorage.getItem('token'));
		}
		return config;
	},
	err => {
		return Promise.reject(err);
	}
)
axios.interceptors.response.use(
	response => {
		if(response.data.code == '90001'){
			store.state.isLoginOut = true;
			router.push({path:'/login'});
		}else{
			if(response.data.code !== undefined){
				return response.data
			}else{
				return response.data.data
			}			
		}
	}
)

instance.interceptors.request.use(
	config => {
		if(JSON.parse(sessionStorage.getItem('token'))){
			config.headers.token = JSON.parse(sessionStorage.getItem('token'));
		}
		return config;
	},
	err => {
		return Promise.reject(err);
	}
)
instance.interceptors.response.use(
	response => {
		if(response.data.code == '90001'){
			store.state.isLoginOut = true;
			router.push({path:'/login'});
		}else{
			if(response.data.code !== undefined){
				return response.data
			}else{
				return response.data.data
			}			
		}
	}
)




//获取可跳转页面路径
let routePath = [];
(function traverse(node) {
    node.forEach(i => {        
        if(i.path != '/') routePath.push(i.path);
        i.children && traverse(i.children)
    })
})(routes);
			
//路由跳转前的判断
router.beforeEach((to, from, next) => {
	let toPath = to.path;
	let user = JSON.parse(sessionStorage.getItem('token'));//是否登录
	if(!user){
		if(toPath == '/login'){
			next();
			return;
		}else{
			next({path: '/login'})
		}
	}else if(user){
		if(toPath == '/login'){ //跳转后登出的页面
			sessionStorage.removeItem('token');
			sessionStorage.removeItem('userInfo');
			next();
		}else if(routePath.indexOf(toPath) == -1){
			next(false)
			if(to.path == '/' && from.path == '/') next({path: '/sendSalaryBill'})
		}else{
			next();
		}
	}
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
window.router = router;
window.axios = axios;
window.qs = qs;



// WEBPACK FOOTER //
// ./src/main.js